export default __webpack_public_path__ + "static/media/profileNameTagIcon.3328716a.svg";